import React, { useEffect, useState } from "react";
import TextInput from "../../components/TextInput";
import { useNavigate } from "react-router";
import ArrowButton from "../../components/ArrowButton";
import OtpInput from "../../components/OtpInput";
import { observer } from "mobx-react-lite";
import { ERROR_CODES } from "../../utils/errorConstants";
import {
  checkUserEmailValidation,
  getBlobToBase64,
  getDecodedToken,
  logEvents,
  setGAProperties,
  trackEventWithScreen,
} from "../../utils/functions";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import SettingsStore from "../../store/SettingsStore";
import { getValue } from "../../utils/indexedDB";
//import moengage from "@moengage/web-sdk";
import { LIAISON, LIAISON_1, LIAISON_2, OTP } from "../../utils/constants";
import { getAnalytics, setUserId } from "firebase/analytics";

const LiaisonOfficerLogin = observer(() => {
  const analytics = getAnalytics();
  const navigate = useNavigate();
  const [panCard] = useState("");
  const [touched, setTouched] = useState({
    emailAddress: false,
    mobileNumber: false,
  });
  const [credentials, setCredentials] = useState({
    mobileNumber: "",
    emailAddress: "",
  });

  const [otp, setOtp] = useState("");
  const [msgForOtp, setOtpMsg] = useState("");
  const [step, setStep] = useState(0);
  const [credsError, setCredsError] = useState({
    state: true,
    message: "",
  });
  const [optError, setOtpError] = useState({
    state: false,
    message: "",
  });

  useEffect(() => {
    if (credentials.mobileNumber.length === 10 && credentials.emailAddress) {
      setCredsError({
        state: false,
        message: "",
      });
      return;
    }
    if (
      credentials.mobileNumber.length < 10 ||
      !credentials.emailAddress ||
      !credentials.mobileNumber
    ) {
      setCredsError({
        state: true,
        message: "",
      });
      return;
    }
  }, [credentials]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTouched({ ...touched, [name]: true });
    if (name === "mobileNumber") {
      if ((value.length <= 10 && /^[0-9]+$/.test(value)) || value === "") {
        setCredentials({ ...credentials, [name]: value });
      }
    } else {
      setCredentials({ ...credentials, [name]: value });
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e);
  };

  const checkvalidation = () => {
    if (checkUserEmailValidation(credentials.emailAddress)) {
      return true;
    } else {
      setCredsError({
        state: true,
        message: "Please enter a valid Email id",
      });
      return false;
    }
  };

  const submitCreds = async () => {
    const val = await getValue("User");
    if (val === undefined) window.location.reload(true);
    else if (checkvalidation()) {
      AuthStore.updateLoadingForLogin(true);
      AuthStore.getServerMsg({
        onSuccess: () => {
          AuthStore._liasionOfficerGenerateOtp(
            {
              MobileNo: credentials.mobileNumber,
              EmailId: credentials.emailAddress,
            },
            {
              onSuccess: (data) => {
                UserStore.setSessionId(data.sessionId);
                setOtpMsg(data.statusMessage);
                AuthStore.updateLoadingForLogin(false);
                setStep(1);
              },
              onFail: (error) => {
                AuthStore.updateLoadingForLogin(false);
                if (
                  error.statusMessage ===
                  "App usage is not enabled for this user"
                ) {
                  setCredsError({
                    state: true,
                    message:
                      "Your Email ID or Mobile Number is not registered with us",
                  });
                } else if (error.statusMessage === "Invalid Email Id") {
                  setCredsError({
                    state: true,
                    message:
                      "Your Email ID or Mobile Number is not registered with us",
                  });
                } else {
                  setCredsError({
                    state: true,
                    message:
                      ERROR_CODES[error.statusCode] || error.statusMessage,
                  });
                }
              },
            },
          );
        },
        onFail: () => {
          setCredsError({
            state: true,
            message: "Sorry we are down for maintenance",
          });
        },
      });

      return;
    }
  };

  const submitOtp = () => {
    AuthStore.updateLoadingForLogin(true);
    AuthStore._liasionOfficerVerifyOtp(
      {
        MobileNo: credentials.mobileNumber,
        Otp: otp,
        SessionId: UserStore.sessionId,
        EmailId: credentials.emailAddress,
        IsPoint: 1,
      },
      {
        onSuccess: (data) => {
          AuthStore.setAuthSession({
            AuthToken: data.token,
            SecreteKey: data.secretKey,
          });
          const { user_id } = getDecodedToken();

          // moengage.add_unique_user_id(user_id).then(() => {
          //   moengage.add_user_attribute("User Type", LIAISON);
          // });

          setUserId(analytics, user_id);

          setGAProperties({ user_type: LIAISON });
          trackEventWithScreen({
            eventName:
              data.client.isFirstTimeLogin === "True" ? LIAISON_1 : LIAISON_2,
            screenName: OTP,
          });
          logEvents(
            data.client.isFirstTimeLogin === "True" ? LIAISON_1 : LIAISON_2,
            { screenName: OTP },
          );
          AuthStore.addRegisteredDevice();
          if (data.client.isFirstTimeLogin === "True") {
            navigate("/upload", {
              state: {
                from: "liaison",
              },
            });
          } else {
            UserStore._getLiaisionLinkedClients({
              onSuccess: (data) => {
                const imageArr = {};
                if (!data.familiesList.length) {
                  navigate("/nolinkedclients");
                  AuthStore.updateLoadingForLogin(false);
                } else {
                  navigate("/linkedclients", { state: { from: "loginPage" } });
                  AuthStore.updateLoadingForLogin(false);
                  data.familiesList.forEach((eachFamily) => {
                    eachFamily.memberList.forEach((eachClient) => {
                      if (eachClient.profile_pic) {
                        SettingsStore.getImageFromAPI({
                          path: eachClient.profile_pic,
                          onSuccess: (imageBlob) => {
                            getBlobToBase64(imageBlob).then((url) => {
                              let resImage = url;
                              imageArr[eachClient.user_id] = resImage;
                              AuthStore.updateSelectFamiliesPageAllImages(
                                imageArr,
                              );
                            });
                          },
                        });
                      }
                    });
                  });
                  UserStore.setLinkedClients(data.familiesList);
                }
              },
              onFail: (error) => {},
            });
          }
        },
        onFail: (error) => {
          AuthStore.updateLoadingForLogin(false);
          setOtpError({
            state: true,
            message: ERROR_CODES[error.statusCode] || error.statusMessage,
          });
        },
      },
    );
    return;
  };

  const handleSubmit = () => {
    step === 0 ? submitCreds() : submitOtp();
  };
  const getMsgForOtp = (msgForOtp) => {
    if (!msgForOtp) return <></>;
    if (msgForOtp?.length > 10) {
      const msgArr = msgForOtp?.split(" ");
      const mobileNumber = msgArr[14]?.replaceAll("X", "•");
      const email = msgArr[10]?.replaceAll("*", "•");
      return (
        <>
          Your OTP has been sent to&nbsp;<span>+91{mobileNumber}</span> and
          &nbsp;
          <span>{email}</span>
        </>
      );
    } else {
      return "";
    }
  };

  const handleOnEnter = (e) => {
    if (e.key === "Enter") {
      submitCreds();
    }
  };

  return (
    <div className="login-box">
      <div>
        {step === 0 && (
          <span>
            <TextInput
              className="mobileNumber"
              type={"phone"}
              value={credentials.mobileNumber}
              error={credsError.mobile}
              errorMsg={credsError.message}
              onChange={handleChange}
              onKeyDown={handleOnEnter}
              label={"Mobile Number"}
              name={"mobileNumber"}
              elementId={"enter-mobile-number"}
            />
            <TextInput
              className="email"
              error={credsError.state}
              errorMsg={credsError.message}
              value={credentials.emailAddress}
              label={"Email ID"}
              type={"email"}
              onChange={handleChange}
              onKeyDown={handleOnEnter}
              name={"emailAddress"}
              elementId={"enter-email-id"}
            />
          </span>
        )}
        {step === 1 && (
          <div className="sentOtpText">
            <p>{getMsgForOtp(msgForOtp)}</p>
            <OtpInput
              otp={otp}
              panCard={panCard}
              setOtpMsg={setOtpMsg}
              setPanError={() => {}}
              onChange={handleOtpChange}
              error={optError.state}
              errorMsg={optError.message}
              setOtpError={setOtpError}
              handleContinue={handleSubmit}
              creds={credentials}
            />
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "auto",
        }}
      >
        <ArrowButton
          type="previous"
          label="Go Back"
          onClick={() => navigate("/login/user")}
          className={"login-page"}
        />
        <ArrowButton
          type="next"
          label="Continue"
          disabled={
            step === 0 ? credsError.state || credsError.mobile : optError.state
          }
          onClick={handleSubmit}
          className={"login-page"}
        />
      </div>
    </div>
  );
});
export default LiaisonOfficerLogin;
